import type { PublicRuntimeConfig } from "@/lib/config/publicRuntimeConfig";
import { buildCognitoLogoutUrl } from "./buildCognitoLogoutUrl";
import { clearCognitoOAuthClientStorage } from "./clearCognitoOAuthClientStorage";
import { getCognitoUserManager } from "./cognitoOidcSettings";

/** Drops the stored user and ends the Cognito session (full-page redirect). */
export const runCognitoLogout = async (
  config: PublicRuntimeConfig,
): Promise<void> => {
  await getCognitoUserManager(config).removeUser();
  clearCognitoOAuthClientStorage();
  const logoutUrl = await buildCognitoLogoutUrl(
    config.cognitoAuthority,
    config.cognitoClientId,
  );
  window.location.assign(logoutUrl);
};
